<template>

  <Layout>

    <div slot="titlebarSecondRow">
      <SubNavBar :struct="tabStructure"></SubNavBar>
    </div>


    <div class="interlocutor">
      <section class="fieldset">
        <div class="table-responsive" v-if="isListInterlocutorsValid">
          <table class="table" style="white-space: nowrap;">
            <thead>
            <tr>
              <th>{{ $t("papers.table.name") }}</th>
              <th>{{ $t("papers.table.function") }}</th>
              <th>{{ $t("papers.table.mail") }}</th>
              <th>{{ $t("papers.table.phone") }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="interlocutor in listInterlocutors">
              <td><strong>{{ interlocutor.nom }}</strong></td>
              <td>{{ interlocutor.libelle }}</td>
              <td>{{ interlocutor.mail }}</td>
              <td>{{ interlocutor.tel }}</td>
            </tr>
            </tbody>
          </table>
        </div>

        <div v-else>
          <div class="no-result">{{ $t("papers.tabInterlocutors.noInterlocutor") }}</div>
        </div>
      </section>
    </div>


  </Layout>

</template>

<script>
import Layout from '@l/BaseWithToolbar'

import SubNavBar from '@c/ui/SubNavBar'
import axios from 'axios';

import {mapGetters, mapActions, mapMutations} from 'vuex'


export default {
  beforeCreate: function () {

  },
  beforeDestroy: function () {

  },
  beforeMount: function () {
    this.$store.commit('UI/viewTitle', $t("papers.titles.interlocutors"))
  },
  beforeUpdate: function () {

  },
  components: {
    Layout,
    SubNavBar
  },
  computed: {
    ...mapGetters({
      listInterlocutors: 'Papers/listInterlocutors'
    }),
    tabStructure() {
      return [
        {name: window.V.$i18n.t("papers.tabsBar.society") , path: 'papersIndex', permission: 'admin-company-client'},
        {name: window.V.$i18n.t("papers.tabsBar.interlocutors") , path: 'interlocutors', permission: 'admin-contacts-client', active: true},
        {name: window.V.$i18n.t("papers.tabsBar.bills") , path: 'bills', permission: 'admin-bills-client'},
        {name: window.V.$i18n.t("papers.tabsBar.administrativeAsk"), path: 'drc', permission: 'admin-bills-client'}
      ];
    },
    isListInterlocutorsValid() {
      return this.listInterlocutors && this.listInterlocutors.length > 0;
    }
  },
  created: function () {
  },
  data() {
    return {}
  },
  destroyed: function () {

  },
  methods: {
    ...mapActions({
      fetchInterlocutors: 'Papers/fetchInterlocutors'
    }),
    ...mapMutations({
      setViewTitle: 'UI/viewTitle',
      showLoading: 'UI/showLoading'
    })
  },
  mounted: function () {
    this.fetchInterlocutors().then(() => {
      this.showLoading(false);
    }); //this.$store.dispatch('Papers/fetchInterlocutors');
  },
  name: '',
  props: {},
  updated: function () {

  },
  watch: {}
}
</script>

<style lang="scss">
.interlocutor {

  padding: 15px;

  .no-result {
    text-align: center;
    font-size: 16px;
    margin: 30px 0;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/papers/Interlocutors.vue